/* global CKEDITOR */
/* eslint-disable new-cap, padded-blocks */

/**
 * This is a modification of the original CKEditor WordCount plugin.
 * https://github.com/w8tcha/CKEditor-wordcount-Plugin
 */

let bbcodePluginLoaded = false;

function strip(html, forTest = false) {
    if (bbcodePluginLoaded) {
        // stripping out BBCode tags [...][/...]
        return html.replace(/\[[^\]]{1,100}\]/gi, '');
    }
    const tmp = new DOMParser().parseFromString(html, 'text/html');
    let text = '';
    if (tmp && tmp.body) {
        if (tmp.body.textContent || tmp.body.innerText) {
            text = tmp.body.textContent || tmp.body.innerText;
        } else if (forTest) {
            const div = document.createElement('div');
            div.innerHTML = html.replace(/\b(alert|confirm|prompt)\b/gi, 'a');
            text = div.textContent || div.innerText || '';
        }
    }
    return text.trim();
}

export function countWords(text, forTest = false) {
    const normalizedText = text
        .replace(/(\r\n|\n|\r)/gm, ' ')
        .replace(/></g, '> <')
        .replace(/&amp;nbsp;/g, ' ')
        .replace('&nbsp;', ' ');

    const stripped = strip(normalizedText, forTest);
    const words = stripped.split(/\s+/);

    for (let wordIndex = words.length - 1; wordIndex >= 0; wordIndex--) {
        if (words[wordIndex].match(/^([\s\t\r\n]*)$/)) {
            words.splice(wordIndex, 1);
        }
    }

    return (words.length);
}

const wordCountPlugin = {
    register(globalCK) {
        if (globalCK.plugins.get('ia-word-count')) {
            return;
        }

        globalCK.plugins.add('ia-word-count', {
            icons: '',
            init: (editorInstance) => { this.init(editorInstance); },
        });
    },

    init(editor) {
        const t = editor.lang.wordcount;
        let defaultFormat = '';
        let lastWordCount = -1;
        let lastCharCount = -1;
        let lastParagraphs = -1;
        let limitReachedNotified = false;
        let timeoutId = 0;
        let notification = null;

        function dispatchEvent(type, currentLength, maxLength) {
            if (typeof document.dispatchEvent === 'undefined') {
                return;
            }

            let cEvent;
            const eventInitDict = {
                bubbles: false,
                cancelable: true,
                detail: {
                    currentLength,
                    maxLength,
                },
            };

            try {
                cEvent = new CustomEvent(`ckeditor.wordcount.${type}`, eventInitDict);
            } catch (error) {
                cEvent = document.createEvent('CustomEvent');
                cEvent.initCustomEvent(
                    type,
                    eventInitDict.bubbles,
                    eventInitDict.cancelable,
                    eventInitDict.detail
                );
            }

            document.dispatchEvent(cEvent);
        }

        // Default Config
        const defaultConfig = {
            showRemaining: false,
            showParagraphs: true,
            showWordCount: true,
            showCharCount: false,
            countBytesAsChars: false,
            countSpacesAsChars: false,
            countHTML: false,
            countLineBreaks: false,
            hardLimit: true,

            // MAXLENGTH Properties
            maxWordCount: -1,
            maxCharCount: -1,
            maxParagraphs: -1,

            // How long to show the 'paste' warning
            pasteWarningDuration: 0,

            // DisAllowed functions
            wordCountGreaterThanMaxLengthEvent(currentLength, maxLength) {
                dispatchEvent('wordCountGreaterThanMaxLengthEvent', currentLength, maxLength);
            },
            charCountGreaterThanMaxLengthEvent(currentLength, maxLength) {
                dispatchEvent('charCountGreaterThanMaxLengthEvent', currentLength, maxLength);
            },

            // Allowed Functions
            wordCountLessThanMaxLengthEvent(currentLength, maxLength) {
                dispatchEvent('wordCountLessThanMaxLengthEvent', currentLength, maxLength);
            },
            charCountLessThanMaxLengthEvent(currentLength, maxLength) {
                dispatchEvent('charCountLessThanMaxLengthEvent', currentLength, maxLength);
            },
        };

        // Get Config & Lang
        const config = CKEDITOR.tools.extend(defaultConfig, editor.config.wordcount || {}, true);
        const { showParagraphs, showWordCount, showCharCount, showRemaining, maxParagraphs, maxWordCount, maxCharCount } = config;
        const { countLineBreaks, countHTML, countSpacesAsChars, countBytesAsChars, hardLimit, pasteWarningDuration } = config;
        if (showParagraphs) {
            if (maxParagraphs > -1) {
                if (showRemaining) {
                    defaultFormat = `${defaultFormat}%paragraphsCount% ${t.ParagraphsRemaining}`;
                } else {
                    defaultFormat = `${defaultFormat}${t.Paragraphs} %paragraphsCount%/${maxParagraphs}`;
                }
            } else {
                defaultFormat = `${defaultFormat}${t.Paragraphs} %paragraphsCount%`;
            }
        }

        if (showParagraphs && (showWordCount || showCharCount)) {
            defaultFormat = `${defaultFormat}, `;
        }

        if (showWordCount) {
            if (maxWordCount > -1) {
                if (showRemaining) {
                    defaultFormat = `${defaultFormat}%wordCount% ${t.WordCountRemaining}`;
                } else {
                    defaultFormat = `${defaultFormat}${t.WordCount} %wordCount%/${maxWordCount}`;
                }
            } else {
                defaultFormat = `${defaultFormat}${t.WordCount} %wordCount%`;
            }
        }

        if (showCharCount && showWordCount) {
            defaultFormat = `${defaultFormat}, `;
        }

        if (showCharCount) {
            if (maxCharCount > -1) {
                if (showRemaining) {
                    const label = countHTML ? t.CharCountWithHTMLRemaining : t.CharCountRemaining;
                    defaultFormat = `${defaultFormat}%charCount% ${label}`;
                } else {
                    const label = countHTML ? t.CharCountWithHTML : t.CharCount;
                    defaultFormat = `${defaultFormat}${label} %charCount%/${maxCharCount}`;
                }
            } else {
                const label = countHTML ? t.CharCountWithHTML : t.CharCount;
                defaultFormat = `${defaultFormat}${label} %charCount%`;
            }
        }

        const format = defaultFormat;

        bbcodePluginLoaded = typeof editor.plugins.bbcode !== 'undefined';

        function counterId(editorInstance) {
            return `cke_wordcount_${editorInstance.name}`;
        }

        function counterElement(editorInstance) {
            return document.getElementById(counterId(editorInstance));
        }

        function stripBody(text) {
            let normalizedText = text;
            const i = normalizedText.search(new RegExp('<body>', 'i'));
            if (i !== -1) {
                const j = normalizedText.search(new RegExp('</body>', 'i'));
                normalizedText = normalizedText.substring(i + 6, j);
            }
            return normalizedText;
        }

        function countBytes(text) {
            const stringLength = text.length;
            const string = String(text || '');
            let count = 0;
            let i;

            for (i = 0; i < stringLength; i++) {
                const partCount = encodeURI(string[i]).split('%').length;
                count += partCount === 1 ? 1 : partCount - 1;
            }
            return count;
        }

        function countCharacters(text) {
            let normalizedText = text;

            // strip body tags
            if (editor.config.fullPage) {
                normalizedText = stripBody(normalizedText);
            }

            if (!countSpacesAsChars) {
                normalizedText = text.replace(/\s/g, '').replace(/&nbsp;/g, '');
            }

            if (countLineBreaks) {
                normalizedText = normalizedText.replace(/(\r\n|\n|\r)/gm, '');
            } else {
                normalizedText = normalizedText.replace(/(\r\n|\n|\r)/gm, '').replace(/&nbsp;/gi, ' ');
            }

            normalizedText = strip(normalizedText).replace(/^([\t\r\n]*)$/, '');

            return countBytesAsChars ? (countBytes(normalizedText)) : (normalizedText.length);
        }

        function countParagraphs(text) {
            return text
                .replace(/&nbsp;/g, ' ')
                .replace(/(<([^>]+)>)/ig, '')
                .replace(/^\s*$[\n\r]{1,}/gm, '++')
                .split('++').length;
        }

        function limitExceeded(editorInstance, notify) {
            limitReachedNotified = true;

            if (hardLimit) {
                editorInstance.execCommand('undo');
            }

            if (!notify) {
                counterElement(editorInstance).className = 'cke_path_item cke_wordcountLimitReached';
                editorInstance.fire('limitReached', { firedBy: 'wordCount.limitReached' }, editor);
            }
        }

        function limitRestored(editorInstance) {
            limitReachedNotified = false;
            counterElement(editorInstance).className = 'cke_path_item';
        }

        function setConfigProp(key, value, editorInstance) {
            (editorInstance.config.wordcount || (editorInstance.config.wordcount = {}))[key] = value;
        }

        function updateCounter(editorInstance) {
            if (!counterElement(editorInstance)) {
                return;
            }

            let paragraphs = 0;
            let wordCount = 0;
            let charCount = 0;

            // BeforeGetData and getData events are fired when calling
            // getData(). We can prevent this by passing true as an
            // argument to getData(). This allows us to fire the events
            // manually with additional event data: firedBy. This additional
            // data helps differentiate calls to getData() made by
            // wordCount plugin from calls made by other plugins/code.
            editorInstance.fire('beforeGetData', { firedBy: 'wordCount.updateCounter' }, editor);
            const text = editorInstance.getData(true);

            editorInstance.fire('getData', { dataValue: text, firedBy: 'wordCount.updateCounter' }, editor);

            if (text) {
                if (showCharCount) {
                    charCount = countCharacters(text);
                }

                if (showParagraphs) {
                    paragraphs = countParagraphs(text);
                }
                wordCount = countWords(text);
            }

            let html = format;
            if (showRemaining) {
                if (maxCharCount >= 0) {
                    html = html.replace('%charCount%', maxCharCount - charCount);
                } else {
                    html = html.replace('%charCount%', charCount);
                }

                if (maxWordCount >= 0) {
                    html = html.replace('%wordCount%', maxWordCount - wordCount);
                } else {
                    html = html.replace('%wordCount%', wordCount);
                }

                if (maxParagraphs >= 0) {
                    html = html.replace('%paragraphsCount%', maxParagraphs - paragraphs);
                } else {
                    html = html.replace('%paragraphsCount%', paragraphs);
                }
            } else {
                html = html.replace('%wordCount%', wordCount).replace('%charCount%', charCount).replace('%paragraphsCount%', paragraphs);
            }
            setConfigProp('wordCount', wordCount, editorInstance);
            setConfigProp('charCount', charCount, editorInstance);

            counterElement(editorInstance).innerText = html;

            if (charCount === lastCharCount && wordCount === lastWordCount && paragraphs === lastParagraphs) {
                if (charCount === maxCharCount || wordCount === maxWordCount || paragraphs > maxParagraphs) {
                    editorInstance.fire('saveSnapshot');
                }
                return;
            }

            // If the limit is already over, allow the deletion of characters/words. Otherwise,
            // the user would have to delete at one go the number of offending characters
            const deltaWord = wordCount - lastWordCount;
            const deltaChar = charCount - lastCharCount;
            const deltaParagraphs = paragraphs - lastParagraphs;

            lastWordCount = wordCount;
            lastCharCount = charCount;
            lastParagraphs = paragraphs;

            if (lastWordCount === -1) {
                lastWordCount = wordCount;
            }
            if (lastCharCount === -1) {
                lastCharCount = charCount;
            }
            if (lastParagraphs === -1) {
                lastParagraphs = paragraphs;
            }

            // Are we on the word limit?
            if ((maxWordCount > -1 && wordCount === maxWordCount)) {
                editorInstance.fire('saveSnapshot');
            }

            // Check for word limit and/or char limit
            if ((maxWordCount > -1 && wordCount > maxWordCount && deltaWord > 0)
                || (maxCharCount > -1 && charCount > maxCharCount && deltaChar > 0)
                || (maxParagraphs > -1 && paragraphs > maxParagraphs && deltaParagraphs > 0)) {

                limitExceeded(editorInstance, limitReachedNotified);
            } else if ((maxWordCount === -1 || wordCount <= maxWordCount)
                && (maxCharCount === -1 || charCount <= maxCharCount)
                && (maxParagraphs === -1 || paragraphs <= maxParagraphs)) {

                limitRestored(editorInstance);
            } else {
                editorInstance.fire('saveSnapshot');
            }

            // update instance
            editorInstance.wordCount =
                {
                    paragraphs,
                    wordCount,
                    charCount,
                };


            // Fire Custom Events
            if (config.charCountGreaterThanMaxLengthEvent && config.charCountLessThanMaxLengthEvent) {
                if (charCount > maxCharCount && maxCharCount > -1) {
                    config.charCountGreaterThanMaxLengthEvent(charCount, maxCharCount);
                } else {
                    config.charCountLessThanMaxLengthEvent(charCount, maxCharCount);
                }
            }

            if (config.wordCountGreaterThanMaxLengthEvent && config.wordCountLessThanMaxLengthEvent) {
                if (wordCount > maxWordCount && maxWordCount > -1) {
                    config.wordCountGreaterThanMaxLengthEvent(wordCount, maxWordCount);
                } else {
                    config.wordCountLessThanMaxLengthEvent(wordCount, maxWordCount);
                }
            }
        }

        function showNotification() {
            if (!notification.isVisible()) {
                notification.show();
            }
        }

        function isCloseToLimits() {
            if (maxWordCount > -1 && maxWordCount - lastWordCount < 5) {
                return true;
            }

            if (maxCharCount > -1 && maxCharCount - lastCharCount < 20) {
                return true;
            }

            return (maxParagraphs > -1 && maxParagraphs - lastParagraphs < 1);
        }

        editor.on('key',
            function keyHandler() {
                if (editor.mode === 'source') {
                    clearTimeout(timeoutId);
                    timeoutId = setTimeout(
                        updateCounter.bind(this, editor),
                        250
                    );
                }
            },
            editor,
            null,
            100);

        editor.on('change',
            function changeHandler() {
                const ms = isCloseToLimits() ? 5 : 250;
                clearTimeout(timeoutId);
                timeoutId = setTimeout(
                    updateCounter.bind(this, editor),
                    ms
                );
            },
            editor,
            null,
            100);

        editor.on('uiSpace',
            (event) => {
                const { html, space } = event.data;
                if ((editor.elementMode === CKEDITOR.ELEMENT_MODE_INLINE && space === 'top') || space === 'bottom') {
                    // eslint-disable-next-line max-len
                    event.data.html = `${html}<div class="cke_wordcount" aria-live="polite" style="" title="${t.title}"><span id="${counterId(editor)}" class="cke_path_item">&nbsp;</span></div>`;
                }
            },
            editor,
            null,
            100);

        editor.on('dataReady',
            () => updateCounter(editor),
            editor,
            null,
            100);

        editor.on('paste',
            (event) => {
                if (!(maxWordCount > 0 || maxCharCount > 0 || maxParagraphs > 0)) {
                    return;
                }

                // Check if pasted content is above the limits
                let wordCount = -1;
                let charCount = -1;
                let paragraphs = -1;

                // BeforeGetData and getData events are fired when calling
                // getData(). We can prevent this by passing true as an
                // argument to getData(). This allows us to fire the events
                // manually with additional event data: firedBy. This additional
                // data helps differentiate calls to getData() made by
                // wordCount plugin from calls made by other plugins/code.
                editor.fire('beforeGetData', { firedBy: 'wordCount.onPaste' }, editor);
                let text = editor.getData(true);
                editor.fire('getData', { dataValue: text, firedBy: 'wordCount.onPaste' }, editor);

                text = `${text}${event.data.dataValue}`;

                if (showCharCount) {
                    charCount = countCharacters(text);
                }

                wordCount = countWords(text);

                if (showParagraphs) {
                    paragraphs = countParagraphs(text);
                }

                // Instantiate the notification when needed and only have one instance
                if (notification === null) {
                    notification = new CKEDITOR.plugins.notification(editor,
                        {
                            message: t.pasteWarning,
                            type: 'warning',
                            duration: pasteWarningDuration,
                        });
                }

                if (maxCharCount > 0 && charCount > maxCharCount && hardLimit) {
                    showNotification();
                    event.cancel();
                }

                if (maxWordCount > 0 && wordCount > maxWordCount && hardLimit) {
                    showNotification();
                    event.cancel();
                }

                if (maxParagraphs > 0 && paragraphs > maxParagraphs && hardLimit) {
                    showNotification();
                    event.cancel();
                }
            },
            editor,
            null,
            100);

        editor.on('afterPaste',
            () => updateCounter(editor),
            editor,
            null,
            100);
    },
};

export default wordCountPlugin;
